import { CREATED_AT, UID } from 'shared/api/query/constants';
import { appFeedback as appFeedbackConfig } from 'shared/api/query/configs.json';

export const appFeedbackChildren = [
  { attr: UID },
  { attr: CREATED_AT },
  { attr: appFeedbackConfig.edges.ignored, default: false },
];
